import React, { useCallback, useState } from "react";
import { Button, Dialog, SpinnerLoader } from "@activecollab/components";
import PropTypes from "prop-types";
import StripeCardFromProvider from "~/components/Subscription/BillingPaymentMethod/StripeCardFormProvider";
import { showErrorToast, showSuccessToast } from "~/components/Toast";

const AddPaymentMethodSecondStep = ({ handleSubmit }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const onSubmit = useCallback(() => {
    showSuccessToast("Payment details updated.");
    setIsLoading(false);
    handleSubmit();
  }, [handleSubmit]);
  const onError = useCallback(() => {
    setIsLoading(false);
    showErrorToast("Failed to update payment details");
  }, []);

  const isValidated = useCallback((e) => {
    setIsValid(e);
  }, []);

  const startLoader = useCallback(() => {
    setTimeout(() => {
      setIsLoading(true);
    }, 0);
  }, []);

  return (
    <div data-testid="stripe-card-form">
      <Dialog.Content>
        <StripeCardFromProvider
          onSubmit={onSubmit}
          onError={onError}
          isValidated={isValidated}
        />
      </Dialog.Content>
      <Dialog.ContentDivider />
      <Dialog.Actions>
        {isLoading ? (
          <div
            className="tw-flex"
            data-testid="spinnerDiv"
          >
            <SpinnerLoader />
            <span className="tw-ml-2">Updating credit card ...</span>
          </div>
        ) : (
          <Button
            type="submit"
            form="stripe_form"
            disabled={!isValid}
            onClick={startLoader}
          >
            Add Credit Card
          </Button>
        )}
      </Dialog.Actions>
    </div>
  );
};

AddPaymentMethodSecondStep.propTypes = {
  handleSubmit: PropTypes.func,
};

export default AddPaymentMethodSecondStep;
